import React from "react";
import { Button } from "../../components/ui";

function FeaturesTabs({ modules, activeId, iconBase, setActiveId, setIsAutoPlaying }) {
  return (
    <div className="mb-8 flex flex-wrap justify-center gap-3 sm:gap-3.5">
      {modules.map((tab) => {
        const Icon = tab.icon;
        const active = activeId === tab.id;
        const tabSurface = active ? `${tab.color}18` : "#ffffff";
        const tabBorder = active ? tab.color : "#e2e8f0";
        const tabText = active ? tab.color : "#475569";
        return (
          <Button
            key={tab.id}
            type="button"
            size="small"
            layout="outline"
            style={{
              backgroundColor: tabSurface,
              borderColor: tabBorder,
              color: tabText,
              boxShadow: active ? `0 8px 20px -12px ${tab.color}99` : undefined,
            }}
            onClick={() => {
              setIsAutoPlaying(false);
              setActiveId(tab.id);
            }}
            onMouseEnter={() => {
              setIsAutoPlaying(false);
              setActiveId(tab.id);
            }}
            onMouseLeave={() => setIsAutoPlaying(true)}
            className="rounded-full border px-4 py-2 text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5"
          >
            <Icon {...iconBase} />
            {tab.name}
          </Button>
        );
      })}
    </div>
  );
}

export default FeaturesTabs;
